import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import useReveal from "@/hooks/useReveal";
import { WhatsappLogo, MapPin, Briefcase } from "@phosphor-icons/react";

export default function Careers() {
  const ref = useReveal();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/careers").then((r) => setItems((r.data || []).filter(x => x.active !== false))).catch(() => {}); }, []);

  const apply = async (role) => {
    try {
      await api.post("/leads", {
        name: "Career applicant",
        email: "applicant@maxine.consulting",
        message: `Interested in role: ${role}`,
        source: "career",
        role,
      });
    } catch { /* ignore */ }
    window.open(
      `https://wa.me/7054986771?text=${encodeURIComponent(`Hi Maxine, I would like to apply for: ${role}`)}`,
      "_blank"
    );
  };

  return (
    <section id="careers" ref={ref} data-testid="careers" className="reveal section border-b border-[color:var(--line)]">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-6">
            <div className="eyebrow">Careers</div>
            <h2 className="font-display font-black text-4xl md:text-5xl mt-4 leading-[1.02]">Come build with us.</h2>
          </div>
          <p className="lg:col-span-5 lg:col-start-8 text-neutral-700 text-lg leading-relaxed">
            We hire experienced product engineers, marketers and cloud specialists. No juniors right now — but we do open the doors twice a year.
          </p>
        </div>

        <div className="border-t border-l border-[color:var(--line)]">
          {items.map((role) => (
            <div
              key={role.id}
              data-testid={`career-${role.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="border-r border-b border-[color:var(--line)] p-8 flex flex-wrap md:flex-nowrap items-start justify-between gap-6 hover:bg-neutral-50 transition-colors duration-200"
            >
              <div className="flex-1 min-w-[220px]">
                <div className="flex items-center gap-4 font-mono text-[10px] uppercase tracking-widest text-neutral-500">
                  <span className="flex items-center gap-1"><Briefcase size={12} weight="bold" /> {role.type}</span>
                  <span className="flex items-center gap-1"><MapPin size={12} weight="bold" /> {role.location}</span>
                </div>
                <h3 className="mt-3 font-display font-bold text-2xl">{role.title}</h3>
                <p className="mt-2 text-neutral-600 max-w-2xl">{role.description}</p>
                {role.responsibilities?.length > 0 && (
                  <ul className="mt-4 grid sm:grid-cols-2 gap-2">
                    {role.responsibilities.map((r) => (
                      <li key={r} className="text-sm text-neutral-700 flex gap-2 items-start">
                        <span className="w-1.5 h-1.5 bg-[color:var(--brand)] mt-1.5 shrink-0" /> {r}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <button
                onClick={() => apply(role.title)}
                data-testid={`career-apply-${role.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="btn-brand shrink-0 mt-2"
              >
                <WhatsappLogo size={16} weight="fill" /> Apply on WhatsApp
              </button>
            </div>
          ))}
          {items.length === 0 && <div className="p-10 text-neutral-500 border-r border-b border-[color:var(--line)]">No open roles right now — check back soon.</div>}
        </div>
      </div>
    </section>
  );
}
